import { Developers } from "features/developers";
import Content from "layouts/agencyPortal/dashboard/content";
import PageLayout from "layouts/agencyPortal/dashboard/pageLayout";

function DevelopersPage() {
  return (
    <PageLayout>
      <Content>
        <Developers />
      </Content>
    </PageLayout>
  );
}

export default DevelopersPage;
